import { render, staticRenderFns } from "./ImageGalleryDrawer.vue?vue&type=template&id=20d0055e&scoped=true"
import script from "./ImageGalleryDrawer.vue?vue&type=script&lang=ts"
export * from "./ImageGalleryDrawer.vue?vue&type=script&lang=ts"
import style0 from "./ImageGalleryDrawer.vue?vue&type=style&index=0&id=20d0055e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0055e",
  null
  
)

export default component.exports